import useViewsSelector from "views/stores/useViewsSelector";
import { selectWidget } from "views/logic/slices/viewSelectors";
const useWidget = (widgetId) => useViewsSelector(selectWidget(widgetId));
export default useWidget;
